/**
 * @module months
 * @description A list of months
 */

export const months = [
	'january',
	'february',
	'march',
	'april',
	'may',
	'june',
	'july',
	'august',
	'september',
	'october',
	'november',
	'december',
] as const;
export type Months = (typeof months)[number];
